import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NAV_ITEMS = [
  { to: '/', label: 'Dashboard', icon: HomeIcon, end: true },
  { to: '/costs', label: 'Total Cost', icon: ChartIcon, end: false },
  { to: '/features', label: 'Service Features', icon: LayersIcon, end: false },
];

export default function Layout() {
  const { user, signOutUser } = useAuth();

  return (
    <div className="min-h-screen flex">
      <aside className="w-64 shrink-0 bg-brand-purple text-white flex flex-col">
        <div className="px-6 pt-8 pb-6 text-center">
          {/* Sized by width with h-auto: a fixed height + preflight's
              max-width clamp squashed the 264×36 wordmark horizontally */}
          <img
            src="/seaovers-logo-inverse.png"
            alt="SeaOvers"
            className="w-44 h-auto mx-auto"
          />
          <div className="mt-5 font-semibold tracking-wide">Cost Monitor</div>
        </div>

        <nav className="flex-1 px-4 space-y-1">
          {NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition ' +
                (isActive
                  ? 'bg-white/15 text-white'
                  : 'text-white/70 hover:bg-white/10 hover:text-white')
              }
            >
              <Icon />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="px-4 py-5 border-t border-white/10 text-sm">
          <div className="text-white/60 truncate mb-3" title={user?.email ?? undefined}>
            {user?.email}
          </div>
          <button
            onClick={signOutUser}
            className="w-full px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition"
          >
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

function HomeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
      <path d="M10 21v-6h4v6" />
    </svg>
  );
}

function ChartIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20V10" />
      <path d="M10 20V4" />
      <path d="M16 20v-7" />
      <path d="M22 20H2" />
    </svg>
  );
}

function LayersIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="m12 3 9 5-9 5-9-5 9-5Z" />
      <path d="m3 13 9 5 9-5" />
    </svg>
  );
}
